import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, inject } from '@angular/core';
import { AvatarUsuarioComponent } from '@shared/components/avatar-usuario/avatar-usuario.component';
import { IconComponent } from '@shared/components/icon/icon.component';
import { UsuarioLogadoInfoComponent } from '@shared/components/usuario-logado-info/usuario-logado-info.component';
import { AppButtonDirective } from '@shared/ui/button/app-button.directive';
import { ModalTrocarSenhaService } from '../../services/modal-trocar-senha.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-usuario-logado-mobile-sidebar',
  imports: [UsuarioLogadoInfoComponent, AppButtonDirective, AvatarUsuarioComponent, IconComponent],
  templateUrl: './usuario-logado-mobile-sidebar.component.html',
  styleUrl: './usuario-logado-mobile-sidebar.component.scss',
  animations: [
    trigger('expandCollapse', [
      state(
        'collapsed',
        style({
          height: '0',
          overflow: 'hidden',
          opacity: '0',
        }),
      ),
      state(
        'expanded',
        style({
          height: '*',
          overflow: 'hidden',
          opacity: '1',
        }),
      ),
      transition('collapsed <=> expanded', [animate('300ms ease-in-out')]),
    ]),
  ],
})
export class UsuarioLogadoMobileSidebarComponent {
  protected isExpanded = false;
  public readonly modalTrocarSenhaService = inject(ModalTrocarSenhaService);
  public readonly router = inject(Router);

  toggle() {
    this.isExpanded = !this.isExpanded;
  }

  toggleModalTrocarSenha() {
    this.modalTrocarSenhaService.toggleModal();
  }

  abrirMeuPerfil() {
    this.router.navigate(['/meu-perfil']);
  }
}
